module.exports = require("cordova/exec");


//////////////////
// WEBPACK FOOTER
// external "cordova/exec"
// module id = 18
// module chunks = 0